@let cols = gridconfig$().cols;
@let gutterSize = gridconfig$().gutterSize;
<div class="app-component-container" id="cards-gallery">
    <div class="content">
        <app-s-header [elemIds]="elementSignals['component-header']()"></app-s-header>
    </div>
    <div class="grid-container" [ngClass]="{'two-cols-grid': cols == 2}">
            <mat-grid-list [cols]="cols" rowHeight="1:1" [gutterSize]="gutterSize">
            @for(elemIds of groupElementSignals['base-card'](); track  $index) {
                <mat-grid-tile class="custom-elevation-z2" [style]="{'z-index': 100 - $index}" [ngClass]="{'isEditMode': isEditMode$()}">
                    <app-base-cards-gallery [elementIds]="elemIds" [hasDescription]="!isSmallScreen$()"></app-base-cards-gallery>
                </mat-grid-tile>
            }
        </mat-grid-list>
    </div>
</div>